import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BreadcrumbService } from 'app/breadcrumb.service';
import { Product } from 'app/products/domain/product';
import { IUser } from 'app/shared/Domains/IUser';
import { ITrainer } from 'app/shared/Domains/trainer';
import { AppServiceManager } from 'common/services/appServiceManager';
import { AuthService } from 'common/services/auth.service';
import { Employee } from '../domain/employee';
import { Configuration } from 'config/config';
import { LanguageService } from 'app/LanguageService/Language.Service';
@Component({
  selector: 'app-employees-listing',
  templateUrl: './employees-listing.component.html',
  styleUrls: ['./employees-listing.component.css']
})
export class EmployeesListingComponent implements OnInit {
  @ViewChild("searchEmployee", { static: false }) searchEmployeeInput: ElementRef;
  // @ViewChild("searchUser", { static: false }) searchUserInput: ElementRef;
  // @ViewChild("searchTrainer", { static: false }) searchTrainerInput: ElementRef;
  loading: boolean;
  first: number = 0;
  firstOfUserTable: number = 0;
  firstOfTrainerTable: number = 0;
  employees: any[];
  employee: Employee;
  sourceEmployees: any[];
  sourceUsers: any[];
  sourceTrainers: any[];
  imgPreview: boolean = false;
  imgPreviewImg: any;
  newEmployeeDialog: boolean = false;
  existingUsersDialog: boolean = false;
  existingTrainersDialog: boolean = false;
  users: any[];
  trainers: any[];
  trainer: ITrainer;
  user: IUser;
  userObject: IUser;
  role: any;
  allDesignation: IDesignationManagement[];

  constructor(
    private LanguageService: LanguageService,
    private messageService: MessageService,
    private breadcrumbService: BreadcrumbService,
    private route: Router,
    private appServiceManager: AppServiceManager,
    private confirmationService: ConfirmationService,
    public config: Configuration,

  ) {
    this.breadcrumbService.setItems([
      { label: 'Employees' }
    ]);
  }
  setLabel(label) {
    return this.LanguageService.GetCurrentLanguage("EmployeesListingComponent", label);
  }
  ngOnInit() {
    this.role = AuthService.getLoggedInRole();
    this.user = AuthService.getLoggedInUser();
    this.employees = [];
    this.employee = new Employee();
    this.userObject = new IUser();
    this.trainer = new ITrainer();
    this.sourceEmployees = [];
    this.sourceUsers = [];
    this.sourceTrainers = [];
    this.users = [];
    this.trainers = [];
    this.getExistingUsers();
    this.getExistingTrainers();
    this.getEmployees();
    this.getAllDesignation();

  }

  ngAfterViewInit() {
    this.searchEmployeeInput.nativeElement.focus();

  }

  getEmployees() {
    this.loading = true;
    this.appServiceManager.get(`employees/company/${this.user.company}/branch/${this.user.branch}/getAllEmployees`).subscribe((res: any) => {
      if (res.length > 0) {
        this.employees = res;
        this.sourceEmployees = res;
      } else {
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  searchLocal(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.employees = Object.assign([], this.sourceEmployees);
      }
      if (!value) {
        this.employees = Object.assign([], this.sourceEmployees);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceEmployees).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.employees = source.filter(distinct);

        if (this.employees.length === 0) {
          this.employees = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.first = 0;
          if (this.employees.length === 1) {
            this.first = 0;
          }
          this.employees = [...this.employees];
        }
      }
    } else {
      this.employees = Object.assign([], this.sourceEmployees);
      this.employees = [...this.employees];
    }
  }

  clear() {
    this.employee = new Employee();
    this.searchLocal("", "");
    this.first = 0;
  }

  onPageChange(event) {
    this.first = event.first;
  }

  deleteEmployee(employee) {
    this.confirmationService.confirm({
      message: "Are you sure you want to Delete?",
      accept: () => {
        this.loading = true;
        this.appServiceManager.delete('employees/deleteEmployee/' + employee._id).subscribe((res: any) => {
          if (res.status === true) {
            this.DeleteEmployee(employee);
            this.messageService.clear();
            this.messageService.add({ severity: 'success', summary: 'Success Message', detail: 'Successfully Deleted' });
          } else {
            this.messageService.clear();
            this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'Something Went Wrong' });
          }
          this.loading = false;
          this.employees = [...this.employees]
        },
          (error) => {
            this.loading = false;
            this.messageService.clear();
            this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
          });
      }
    });
  }

  DeleteEmployee(employee) {
    let employees = [...this.employees];
    let index = this.employees.indexOf(employee);
    if (index > -1) {
      employees.splice(index, 1);
      return this.employees = employees;
    }
  }

  openPhoto(imgUri, gender) {
    this.imgPreview = true;
    if (!imgUri) {
      // Handle the case when imgUri is empty or null
      if (gender == 'Female')
        this.imgPreviewImg = 'avatarGirlImage.png';

    } else {

      const isGirlAvatar = imgUri === 'avatarGirlImage.png';

      if (isGirlAvatar) {
        this.imgPreviewImg = 'avatarGirlImage.png';
      } else {
        // Handle other images
        this.imgPreviewImg = imgUri;
      }
    }
  }
  closePhotoPreview() {
    this.imgPreview = false;
    this.imgPreviewImg = "";
  }

  viewEmployee(employee) {
    this.route.navigateByUrl('employee/' + employee._id);
  }

  selectUserAsEmployee(userAsEmployee) {
    let checkIfUserExistAsEmployee = this.employees.filter(x => x.userId == userAsEmployee._id);
    if (checkIfUserExistAsEmployee.length > 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'User already added as employee' });
    } else {
      let employeeData = userAsEmployee;
      localStorage.setItem("EmployeeAsUserObject", JSON.stringify(employeeData));
      setTimeout(() => {
        this.route.navigateByUrl('/employee');
      }, 1000);
    }
  }

  selectTrainerAsEmployee(trainerAsEmployee) {
    let checkIfTrainerExistAsEmployee = this.employees.filter(x => x.trainerId == trainerAsEmployee._id);
    if (checkIfTrainerExistAsEmployee.length > 0) {
      this.messageService.clear();
      this.messageService.add({ severity: 'warn', summary: 'Warning Message', detail: 'Trainer already added as employee' });
    } else {
      let employeeData = trainerAsEmployee;
      localStorage.setItem("EmployeeAsTrainerObject", JSON.stringify(employeeData));
      setTimeout(() => {
        this.route.navigateByUrl('/employee');
      }, 1000);
    }
  }

  getExistingUsers() {
    this.loading = true;
    this.appServiceManager
      .get("branches/" + this.user.branch + "/users").subscribe(
        (res: any) => {
          if (res.length > 0) {
            res = this.role.name === 'Super Admin'
            ? res.filter((value: { role: any }) => value.role !== "Trainer")
            : res.filter((value: { userRole: any }) => value.userRole.name !== "Super Admin" && value.userRole.name !== "Trainer");
            this.users = res;
            this.sourceUsers = res;
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "No Record Found",
            });
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error.error.message,
          });
        }
      );
  }

  searchLocalUsers(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (!value) {
        this.users = Object.assign([], this.sourceUsers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceUsers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.users = source.filter(distinct);

        if (this.users.length === 0) {
          this.users = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.firstOfUserTable = 0;
          if (this.users.length === 1) {
            this.firstOfUserTable = 0;
          }
          this.users = [...this.users];
        }
      }
    } else {
      this.users = Object.assign([], this.sourceUsers);
      this.users = [...this.users];
    }
  }

  clearUserSearchField() {
    this.userObject = new IUser();
    this.searchLocalUsers("", "");
    this.firstOfUserTable = 0;
  }

  onPageChangeUsersTable(event) {
    this.firstOfUserTable = event.first;
  }

  getExistingTrainers() {
    this.loading = true;
    this.appServiceManager
      .get(
        "Trainers/company/" + this.user.company + "/branch/" + this.user.branch
      )
      .subscribe(
        (res: any) => {
          if (res.length > 0) {
            this.trainers = res;
            this.sourceTrainers = res;
          } else {
            this.messageService.clear();
            this.messageService.add({
              severity: "info",
              summary: "Info Message",
              detail: "No Record Found",
            });
          }
          this.loading = false;
        },
        (error) => {
          this.loading = false;
          this.messageService.clear();
          this.messageService.add({
            severity: "error",
            summary: "Error Message",
            detail: error.error.message,
          });
        }
      );
  }

  searchLocalTrainers(value, type) {
    let matchedName = [];
    if (value !== null && value !== undefined && value.toString().length > 0) {
      if (value == "") {
        this.trainers = Object.assign([], this.sourceTrainers);
      }
      if (!value) {
        this.trainers = Object.assign([], this.sourceTrainers);
      }
      if (value != "") {
        if (type === "name") {
          matchedName = Object.assign([], this.sourceTrainers).filter(
            cust => cust.name ? cust.name.toLowerCase().indexOf(value.toLowerCase()) > -1 : null);
        }

        const distinct = (value, index, self) => {
          return self.indexOf(value) === index;
        }
        const source = matchedName;
        this.trainers = source.filter(distinct);

        if (this.trainers.length === 0) {
          this.trainers = [];
          this.messageService.clear();
          this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
        } else {
          this.firstOfTrainerTable = 0;
          if (this.trainers.length === 1) {
            this.firstOfTrainerTable = 0;
          }
          this.trainers = [...this.trainers];
        }
      }
    } else {
      this.trainers = Object.assign([], this.sourceTrainers);
      this.trainers = [...this.trainers];
    }
  }

  clearTrainersSearchField() {
    this.trainer = new ITrainer();
    this.searchLocalTrainers("", "");
    this.firstOfTrainerTable = 0;
  }

  onPageChangeTrainersTable(event) {
    this.firstOfTrainerTable = event.first;
  }

  getAllDesignation() {
    this.appServiceManager.get(`hr/getAllDesignation/company/${this.user.company}/branch/${this.user.branch}`).subscribe((res: any) => {
      if (res.length > 0) {
        this.allDesignation = res;
      } else {
        this.allDesignation = [];
        this.messageService.clear();
        this.messageService.add({ severity: 'info', summary: 'Info Message', detail: 'No Record Found' });
      }
      this.loading = false;
    },
      (error) => {
        this.loading = false;
        this.messageService.clear();
        this.messageService.add({ severity: 'error', summary: 'Error Message', detail: error });
      });
  }

  getDesignationTitle(designationId) {
    let designationObject = this.allDesignation.find(x => x._id == designationId);
    return designationObject.name;
  }

  focusUserSearchInput() {
    this.clearUserSearchField();
    setTimeout(() => {
      document.getElementById("searchUser").focus();
    }, 300);
  }

  focusTrainerSearchInput() {
    this.clearTrainersSearchField();
    setTimeout(() => {
      document.getElementById("searchTrainer").focus();
    }, 300);
  }

}

class IDesignationManagement {
  _id: String
  name: String;
  currency: String;
  salary: Number;
  branch: String;
  company: String;
  isDelete: Boolean;
  createdBy: String;
  createdDate: Date;
  modifiedBy: String;
  modifiedDate: Date;
}
